import { mode } from '@chakra-ui/theme-tools';
const styles = {
    global: (props) => ({
        body: {
            fontFamily: 'body',
            color: mode('gray.600', 'white')(props),
            bg: mode('white', 'gray.600')(props),
            lineHeight: 'base',
            '*::placeholder': {
                color: mode('gray.400', 'whiteAlpha.400')(props),
            },
            '*, *::before, &::after': {
                borderColor: mode('gray.200', 'whiteAlpha.300')(props),
            },
        },
    }),
};
export default styles;
//# sourceMappingURL=styles.js.map